export default __webpack_public_path__ + "static/media/bootstrap.2bb17943.png";